import {
  alpha,
  Box,
  Button,
  Container,
  Grid,
  Skeleton,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import { useContext, useState } from 'react';
import { backendURL } from 'redux/reducers/settings';
import {
  useFetchListQuery,
  useFetchThisCategoryQuery,
  useListAllCourseQuery
} from 'redux/reducers/user/dashboard/tms-course';
import CourseList from './CourseList';

function Course() {
  const theme = useTheme();
  const [categoryType, setCategoryType] = useState('');
  const { data: categoryList } = useFetchListQuery();
  const { data: allCourse, isLoading: allcourseLoading } = useListAllCourseQuery();
  const { data: Category, isLoading: CategoryLoading, refetch: categoryRefetch } = useFetchThisCategoryQuery(categoryType);
  const { appConfig } = useContext(ConfigurationContext);

  const handleCategoryChange = (id: string) => {
    setCategoryType(id);
    if (id !== '') categoryRefetch();
  };

  const currentCourses = !categoryType ? allCourse : Category;
  const isLoading = allcourseLoading || CategoryLoading;

  return (
    <Box sx={{ bgcolor: '#fbfcfd', minHeight: '100vh' }}>
      {/* --- HERO SECTION --- */}
      <Box sx={{ 
        bgcolor: 'white', 
        borderBottom: '1px solid', 
        borderColor: 'divider',
        pt: { xs: 6, md: 10 },
        pb: { xs: 6, md: 10 },
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.03)} 0%, ${alpha(theme.palette.primary.main, 0.01)} 100%)`
      }}>
        <Container maxWidth="lg">
          <Grid container alignItems="center" spacing={4}>
            <Grid item xs={12} md={7}>
              <Typography variant="overline" color="primary" sx={{ fontWeight: 800, letterSpacing: 2 }}>
                LEARNING PORTAL
              </Typography>
              <Typography variant="h2" sx={{ fontWeight: 900, mb: 2, color: 'text.primary', fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
                {appConfig?.title ?? 'Enhance Your Skills'}
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400, lineHeight: 1.6, maxWidth: 600 }}>
                Building institutional capacity through professional management and
                specialized training consulting services.
              </Typography>
            </Grid>
            <Grid item xs={12} md={5} sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end' }}>
              <Box sx={{ 
                p: 4, borderRadius: '50%', 
                bgcolor: 'white', 
                boxShadow: '0 20px 50px rgba(0,0,0,0.05)',
                border: '1px solid', borderColor: 'divider'
              }}>
                <img src={backendURL + appConfig?.logo} width={120} height={120} alt="Logo" style={{ objectFit: 'contain' }} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 8 }}>
        {/* --- CATEGORY FILTERS --- */}
        {/* <Stack direction="row" spacing={1} sx={{ 
          mb: 6, 
          overflowX: 'auto', 
          pb: 2,
          '&::-webkit-scrollbar': { display: 'none' },
          justifyContent: { xs: 'flex-start', md: 'center' },
          gap:2

        }}>
          <Button
            variant={categoryType === '' ? "contained" : "text"}
            onClick={() => handleCategoryChange('')}
            sx={{ 
              borderRadius: 10, px: 4, py: 1, whiteSpace: 'nowrap',
              boxShadow: categoryType === '' ? theme.shadows[4] : 'none',
              fontSize:12,
              fontWeight: 700,
              bgcolor: categoryType === '' ? 'primary.main' : 'white',
              color: categoryType === '' ? 'white' : 'text.primary',
              border: '1px solid', borderColor: categoryType === '' ? 'primary.main' : 'divider'
            }}
          >
            All Courses
          </Button>
          {categoryList?.map((item: any) => (
            <Button
              key={item.course_category_id}
              variant={categoryType === item.course_category_id ? "contained" : "text"}
              onClick={() => handleCategoryChange(item.course_category_id)}
              sx={{ 
                borderRadius: 10, px: 4, py: 1, 
                fontWeight: 700,
              fontSize:12,

                bgcolor: categoryType === item.course_category_id ? 'primary.main' : 'white',
                color: categoryType === item.course_category_id ? 'white' : 'text.primary',
                border: '1px solid', borderColor: categoryType === item.course_category_id ? 'primary.main' : 'divider',
                '&:hover': { bgcolor: categoryType === item.course_category_id ? 'primary.dark' : '#f8f9fa' }
              }}
            >
              {item.name}
            </Button>
          ))}
        </Stack> */}

        {/* --- COURSE GRID --- */}
        {isLoading ? (
          <Grid container spacing={4}>
            {[1, 2, 3, 4].map((n) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={n}>
                <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 4, mb: 2 }} />
                <Skeleton width="60%" height={30} sx={{ mb: 1 }} />
                <Skeleton width="90%" height={20} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container spacing={4}>
            {currentCourses?.length ? (
              currentCourses.map((item: any) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                  <CourseList
                    id={item.id.toString()}
                    images={item.image}
                    title={item.title}
                    category={item.category_details?.name}
                    description={item.description}
                  />
                </Grid>
              ))
            ) : (
              <Box sx={{ width: '100%', textAlign: 'center', py: 10 }}>
                <Typography color="text.secondary">No courses found in this category.</Typography>
              </Box>
            )}
          </Grid>
        )}
      </Container>
    </Box>
  );
}

export default Course;